var _style, _path, _polygon, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 7.7 7.7",
    style: {
      enableBackground: "new 0 0 7.7 7.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#5C5C5C;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8,4.3c-0.9,0.4-1.5,1.2-1.5,2.2h4.4L18,2c-0.2-0.1-0.4-0.2-0.6-0.1c-0.2,0.2-0.2,0.4,0,0.6L18.8,4.3 L18.8,4.3z M22.2,6.5c0-1.2-0.8-2.1-2-2.3L22.2,6.5z M19.8,1.1c-0.6,0-1.2,0.4-1.3,1l1.3,1.6c0.7,0,1.3-0.6,1.3-1.3 C21,1.7,20.5,1.1,19.8,1.1L19.8,1.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "20,-3.5 17.7,-3.5 17.7,-5.8 16.9,-5.8 16.9,-3.5 14.7,-3.5 14.7,-2.8 16.9,-2.8 16.9,-0.5 17.7,-0.5  17.7,-2.8 20,-2.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9-4.2L4.8-5.3c0.8-1,0.8-2.6-0.2-3.5C4.1-9.3,3.4-9.6,2.7-9.6S1.4-9.3,0.9-8.8S0.1-7.7,0.1-7s0.3,1.4,0.8,1.9 C1.4-4.6,2-4.3,2.7-4.3c0.6,0,1.2-0.2,1.6-0.6l1.1,1.1c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1C6-3.9,6-4.1,5.9-4.2L5.9-4.2z  M4.8-7c0,0.6-0.2,1.1-0.6,1.4C3.8-5.2,3.3-4.9,2.7-4.9S1.7-5.1,1.3-5.5C0.9-5.9,0.7-6.4,0.7-7S0.9-8,1.3-8.4C1.7-8.8,2.2-9,2.7-9 c0.6,0,1.1,0.2,1.4,0.6C4.6-8,4.8-7.5,4.8-7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1,6.9C1.2,6.9,1.3,7,1.4,7s0.2,0,0.3-0.1l2.2-2.2l2.2,2.2C6.2,6.9,6.4,7,6.4,7c0.1,0,0.2,0,0.3-0.1 c0.2-0.2,0.2-0.4,0-0.6L4.5,4l2.2-2.2c0.2-0.2,0.2-0.4,0-0.6C6.6,1,6.3,1,6.1,1.2L3.9,3.4L1.7,1.2c-0.2-0.2-0.4-0.2-0.6,0 s-0.2,0.4,0,0.6L3.3,4L1.1,6.3C0.9,6.4,0.9,6.7,1.1,6.9L1.1,6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2);
export default __webpack_public_path__ + "static/media/close2.2c3a1e9a.svg";
export { ForwardRef as ReactComponent };